<template>
    <app-button :to="to"
                :href="href"
                v-bind="$listeners">
        <app-icon class="return-button__icon" value="icon-return" slot="icon"/>
        <slot v-if="$slots.default"/>
        <template v-else>返回</template>
    </app-button>
</template>

<script>
    import AppIcon from '@components/AppIcon'
    import AppButton from '@components/AppButton'

    export default {
        name: "ReturnButton",
        props: {
            to: {
                type: [String, Object],
                default: null
            },
            href: {
                type: String,
                default: null
            }
        },
        components: {
            AppIcon,
            AppButton
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";

    .return-button__icon {
        font-weight: $fontWeightBolder;
    }
</style>